import React from "react"
import { Link } from "gatsby"

import { rhythm, scale } from "../utils/typography"

class Layout extends React.Component {
  render() {
    const { title, children } = this.props
    let header, footer

    header = (
      <h1
        style={{
          ...scale(1),
          marginBottom: rhythm(1),
          marginTop: 0,
          padding: `${rhythm(0.5)} ${rhythm(3 / 4)}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgb(174,46,53)",
          color: "white",
          fontWeight: 400,
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          {title}
        </Link>
      </h1>
    )

    footer = (
      <footer
        style={{
          padding: `${rhythm(1 / 4)} ${rhythm(0)}`,
          textAlign: "center",
          backgroundColor: "#8795A1",
          color: "#FFFFFF",
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          {title}
        </Link>
        <br />
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
          }}
          to={779}
        >
          Privacy Policy
        </Link>
        <br />
        since 2017 - {new Date().getFullYear()}
      </footer>
    )

    return (
      <>
        <header>{header}</header>
        <div
          style={{
            margin: `0 auto`,
            maxWidth: rhythm(24),
            padding: `${rhythm(0)} ${rhythm(3 / 4)}`,
          }}
        >
          <main>{children}</main>
        </div>
        {footer}
      </>
    )
  }
}

export default Layout
